import Vue from 'vue';
import JudgingDashboard from './JudgingDashboard';
import store from '../../lib/store';

export default function () {
  const judgingDashboardEl = document.getElementById('judging-dashboard');

  if (judgingDashboardEl) {
    const judgingDashboard = new Vue({
      el: judgingDashboardEl,
      components: {
        JudgingDashboard
      },
      store
    });

    $(document).one('pjax:end', () => {
      judgingDashboard.$destroy();
    });
  }
};
